import { createColumnHelper } from '@tanstack/react-table';

import { SKU } from 'types/sku';

const col = createColumnHelper<SKU>();

export const buildSkuCasesColumns = () => [
  col.accessor((sku) => sku?._id, {
    id: 'id',
    header: 'ID',
    minSize: 150,
  }),
  col.accessor((sku) => sku?.prefix || '-', {
    id: 'prefix',
    header: 'SKU Prefix',
    minSize: 100,
  }),
  col.accessor((sku) => sku?.name || '-', {
    id: 'name',
    header: 'SKU Name',
    minSize: 150,
  }),
];
